import { render } from "./PetSchedule.vue?vue&type=template&id=5b3c57e9&scoped=true"
import script from "./PetSchedule.vue?vue&type=script&lang=js"
export * from "./PetSchedule.vue?vue&type=script&lang=js"

import "./PetSchedule.vue?vue&type=style&index=0&id=5b3c57e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3c57e9"]])

export default __exports__